<template>
  <svg width="215" height="200" viewBox="0 0 215 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M96.0603 8.80052C98.2243 3.4853 103.464 0 109.291 0H200.736C210.817 0 217.711 10.0034 213.967 19.1995L143.94 191.199C141.776 196.515 136.536 200 130.709 200H39.2637C29.1826 200 22.2892 189.997 26.0332 180.801L96.0603 8.80052Z"
      fill="url(#paint0_linear_14591_313839)"
    />
    <path
      d="M60.026 120C37.4106 120 17.7078 107.463 7.50785 88.9499C-14.9951 48.1313 16.0435 -1.42061 61.353 0.0311673C90.1762 0.616381 114.523 21.8754 119.168 50.1457C125.263 86.6316 97.0924 120 60.026 120Z"
      fill="url(#paint1_radial_14591_313839)"
    />
    <mask id="mask0_14591_313839" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="-1" width="120" height="121">
      <path
        d="M60.026 120C37.4106 120 17.7078 107.463 7.50785 88.9499C-14.9951 48.1312 16.0435 -1.42074 61.353 0.0310452C90.1762 0.61626 114.523 21.8753 119.168 50.1457C125.263 86.6315 97.0924 120 60.026 120Z"
        fill="url(#paint2_radial_14591_313839)"
      />
    </mask>
    <g mask="url(#mask0_14591_313839)">
      <path
        opacity="0.2"
        d="M83.8335 69.7054C81.3481 69.0864 80.6621 72.1813 82.0679 72.879C83.4736 73.588 87.0048 75.7038 87.7133 74.2858C88.4218 72.879 86.6562 70.4144 83.8335 69.7054Z"
        fill="#082BD5"
      />
      <path
        opacity="0.2"
        d="M108.518 43.5958C106.111 44.1472 103.233 45.3627 105.695 47.1296C108.169 48.8965 112.038 48.1875 112.398 46.0717C112.746 43.9447 113.106 42.5379 108.518 43.5958Z"
        fill="#082BD5"
      />
      <path
        opacity="0.2"
        d="M60.2059 100.407C55.0328 97.3004 47.5093 96.175 46.8008 99.3487C46.0923 102.522 51.0292 107.463 57.0233 106.754C63.0286 106.056 63.7371 102.522 60.2059 100.407Z"
        fill="#082BD5"
      />
      <path
        opacity="0.2"
        d="M77.0748 117.535C72.4078 118.92 67.5046 119.752 62.4327 119.944C63.591 112.595 70.5747 114.913 74.3083 115.926C75.3992 116.23 76.3101 116.826 77.0748 117.535Z"
        fill="#082BD5"
      />
      <path
        opacity="0.2"
        d="M27.4128 100.058C29.6958 101.059 31.2927 96.175 28.1213 91.9435C24.95 87.7119 23.533 82.4112 19.6532 81.3534C15.7734 80.2955 13.6592 94.0593 27.4128 100.058Z"
        fill="#082BD5"
      />
      <path opacity="0.2" d="M11.8937 82.7601C10.6454 82.9852 10.1281 85.5849 12.9508 85.9338C15.7735 86.2939 15.7735 82.0624 11.8937 82.7601Z" fill="#082BD5" />
      <path
        opacity="0.2"
        d="M43.2808 68.2986C40.7955 68.0735 38.3439 69.3565 38.6925 72.1813C39.0411 75.0061 42.9209 72.1813 44.6865 72.1813C46.4521 72.1813 47.1606 68.6475 43.2808 68.2986Z"
        fill="#082BD5"
      />
      <path
        d="M44.9293 58.4837C32.8727 60.5969 31.097 60.9454 20.1036 70.1177C12.8312 76.1764 5.2421 74.2205 0.944258 72.1972C0.14124 68.2854 -0.288574 64.2276 -0.288574 60.0686C-0.288574 43.0278 6.87075 27.6395 18.3618 16.7361C20.7256 18.1299 23.1686 20.0183 25.0687 22.5362C30.3845 29.5841 29.3213 32.4055 44.9293 40.5099C60.5259 48.6144 56.9858 56.3704 44.9293 58.4837Z"
        fill="#00CC88"
      />
      <path
        d="M114.65 34.194C103.521 31.8784 95.9321 44.3892 88.3543 43.4788C79.4872 42.4221 81.9754 29.383 74.522 15.6358C70.7897 8.75654 70.5295 3.99053 71.1968 0.955566C90.4579 4.48511 106.496 17.1195 114.65 34.194Z"
        fill="#00CC88"
      />
      <path
        d="M120.289 60.0685C120.289 83.3253 106.965 103.48 87.4892 113.416C83.0444 106.436 90.2489 101.254 98.8333 95.8473C109.476 89.1479 99.5458 86.3265 101.31 75.4007C103.086 64.4748 96.3451 63.7667 99.5345 54.6056C101.808 48.0636 113.661 54.2684 120.255 58.3599C120.277 58.922 120.289 59.4952 120.289 60.0685Z"
        fill="#00CC88"
      />
      <path
        d="M63.7266 78.2221C57.2799 80.2117 53.7964 72.5794 45.6418 74.3441C37.4872 76.1089 30.7464 90.5531 41.7398 90.2046C52.7332 89.8562 55.5721 88.4398 63.7266 94.0826C71.8812 99.7254 81.4609 95.8474 84.2998 87.0348C87.1273 78.2221 85.3516 71.5227 63.7266 78.2221Z"
        fill="#00CC88"
      />
      <path
        d="M77.197 51.7842C73.804 52.8633 72.9444 54.6056 74.0076 56.7188C75.0707 58.832 79.3233 58.4836 81.4496 61.6534C83.5759 64.8233 88.903 68.7013 90.3167 61.6534C91.7418 54.6056 85.001 49.3113 77.197 51.7842Z"
        fill="#00CC88"
      />
      <path
        d="M56.8967 5.39393C48.0159 5.39393 43.7568 10.3896 35.5897 13.2459C30.7189 14.9414 26.8676 12.9727 24.5455 11.1065C34.423 4.02838 46.5094 -0.136536 59.57 -0.136536C60.0231 -0.136536 60.4648 -0.136548 60.9066 -0.113789C61.5296 2.458 61.303 5.39393 56.8967 5.39393Z"
        fill="#00CC88"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_14591_313839" x1="157.668" y1="1.0855e-06" x2="87.5433" y2="200.709" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFD60A" />
        <stop offset="1" stop-color="#FAC30F" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_14591_313839"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(61.9091 60) rotate(-17.0541) scale(59.0511 59.0944)"
      >
        <stop stop-color="#4E6CFF" />
        <stop offset="1" stop-color="#0A33FF" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_14591_313839"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(61.9091 60) rotate(-17.0541) scale(59.0511 59.0945)"
      >
        <stop stop-color="#5572FF" />
        <stop offset="1" stop-color="#0A33FF" />
      </radialGradient>
    </defs>
  </svg>
</template>
